// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"ecc294df","160":"52b08478","208":"60214158","293":"4ebf4de5","453":"ff15191b","516":"7def7342","519":"3a694eef","917":"e19738bc","946":"cfdbfdf1"}[chunkId] + ".chunk.js";
};